var map = {
	"./ananthi.webp": 92258,
	"./arumugam.webp": 26000,
	"./balasubramanie.webp": 97958,
	"./deepa.webp": 90476,
	"./jamunadevi.webp": 85135,
	"./karthika.webp": 88610,
	"./malathieswaran.webp": 2438,
	"./maragatham.webp": 47302,
	"./rukumanikhandhan.webp": 11442,
	"./sathiyapriya.webp": 67231,
	"./shanmugapriya.p.webp": 72790,
	"./srithar.webp": 2042,
	"./suganthe.webp": 36758,
	"./varshini.webp": 92819,
	"./vijay.webp": 59730,
	"./yuvarani.webp": 41212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87863;